import React from 'react';
import { Icon } from './Icon.js';
export const IconGridCircleFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("circle", { cx: "5", cy: "5", r: "3.25", fill: "currentColor" }),
        React.createElement("circle", { cx: "13", cy: "5", r: "3.25", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "5", cy: "13", r: "3.25", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "13", cy: "13", r: "3.25", fill: "currentColor" })));
};
//# sourceMappingURL=IconGridCircleFill18.js.map